module.exports = __webpack_public_path__ + "static/img/er.1ef5f50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/er.jpg
// module id = iT7U
// module chunks = 10